import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import Select from "react-select";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_EMPLOYEES_LIST,
} from "../RollCallConfig/RollCallConfig";
import { Collapse, Spin } from "antd";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  flexRender,
} from "@tanstack/react-table";
import PropTypes from "prop-types";
const { Panel } = Collapse;

const buildColumns = (headers, pageIndex, pageSize, id) => [
  {
    header: "S.No",
    cell: ({ row }) => pageIndex * pageSize + row.index + 1,
  },
  ...headers.map((h) => ({
    header: h,
    accessorKey: h,
    cell: (info) => {
      const value = info.getValue();

      // 👇 ONLY for report 107 → Map column
      if (id === "107" && h === "Map" && typeof value === "string") {
        return <span dangerouslySetInnerHTML={{ __html: value }} />;
      }

      return value ?? "-";
    },
  })),
];

const RollcallReports = () => {
  const { id } = useParams();
  // const groupColumns = GROUPING_CONFIG[id] || [];
  // const isGroupedReport = !!GROUPING_CONFIG[id];
  // const isGroupedExport = !!EXPORT_GROUPING_CONFIG[id];
  const [Loading, setLoading] = useState();
  const [headerLoading, setHeaderLoading] = useState();
  const [headerData, setHeaderData] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [deptData, setDeptData] = useState([]);
  const [branchdata, setbranchdata] = useState([]);
  const [shiftdata, setshiftdata] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedDep, setSelectedDep] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedShift, setSelectedShift] = useState(null);
  const [selectedStartDt, setSelectedStartDt] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [selectedEndDt, setSelectedEndDt] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [selectedmonth, setSelectedmonth] = useState("");
  const [selectedYear, Setselectedyear] = useState("");
  const [reportData, setReportData] = useState([]);
  const [colData, SetColdata] = useState([]);

  const [selectedFormattedStDt, setSelectedFormatedStDt] = useState("");
  const [selectedFormattedEndDt, setSelectedFormatedEndDt] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);

  const [searchText, setSearchText] = useState("");
  const handleSearch = (e) => {
    setSearchText(e.target.value);
    setPageIndex(0); // reset pagination on search
  };

  const navigate = useNavigate();
  const location = useLocation();

  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  // const pageSize = 10;
  const [pageSize, setPageSize] = useState(10);
  const pageSizeOptions = [
    { value: 10, label: "10" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  const [headers, setHeaders] = useState([]);
  const [data, setData] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [activeKey, setActiveKey] = useState(1);
  const togglePanel = () => {
    setActiveKey(activeKey ? null : "1");
  };
  const filteredData = useMemo(() => {
    if (!searchText) return data;
    const lower = searchText.toLowerCase();
    return data.filter((row) =>
      headers.some((h) =>
        String(row[h] ?? "")
          .toLowerCase()
          .includes(lower),
      ),
    );
  }, [data, searchText, headers]);

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (!id) return;
    if (tokenData && superIdData) {
      const fetchHeaderData = async () => {
        setHeaderLoading(true);
        try {
          const res = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/reports/getreporthead?reportiid=${id}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          const data = await res.json();

          if (data?.status) {
            setHeaderData(data.ResultData || []);
          } else {
            console.error("Failed to load report header:", data?.Message);
          }
        } catch (err) {
          console.error("Fetch error:", err);
        } finally {
          setHeaderLoading(false);
        }
      };

      fetchHeaderData();
    }
  }, [id, superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_EMPLOYEES_LIST}?superid=${superIdData}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setEmployees(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setEmployees([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [superIdData, tokenData]);

  const empOptions = [
    { value: "", label: "All" },
    ...employees.map((emp) => ({
      value: emp.RegId,
      label: `${emp.UserName} (${emp.Badge})`,
    })),
  ];

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDepartments = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to fetch departments");
          }
          const data = await response.json();
          if (data.status) {
            const activeRecords = data.ResultData?.filter(
              (item) => item.IsActive,
            );
            setDeptData(activeRecords);
          } else {
            console.error("Invalid department response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching departments:", error.message);
        }
      };
      fetchDepartments();
    }
  }, [tokenData, superIdData]);

  const departmentOptions = [
    { value: "", label: "All" },
    ...(deptData?.map((item) => ({
      value: item.DepartmentId,
      label: item.Name,
    })) ?? []),
  ];

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchbranches = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,

            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to fetch departments");
          }

          const data = await response.json();

          if (data.status) {
            setbranchdata(data.ResultData);
          } else {
            console.error("Invalid department response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching departments:", error.message);
        }
      };
      fetchbranches();
    }
  }, [superIdData, tokenData]);

  const branchOptions = [
    { value: "", label: "All" },
    ...(branchdata?.map((item) => ({
      value: item.BranchId,
      label: item.Name,
    })) ?? []),
  ];

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchShifts = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/shifts/getShiftsTypes?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const data = await response.json();

          setshiftdata(data.ResultData);
        } catch (err) {
          console.log(err.message);
        }
      };

      fetchShifts();
    }
  }, [superIdData, tokenData]);

  const shiftOptions = [
    { value: "", label: "All" },
    ...(shiftdata?.map((item) => ({
      value: item.shiftid,
      label: item.Name,
    })) ?? []),
  ];

  const handleStartDtChange = (e) => {
    setSelectedStartDt(e.target.value);
  };
  const handleEndDtChange = (e) => {
    setSelectedEndDt(e.target.value);
  };

  const reportName = headerData[0]?.name;
  const reportFilters = headerData[0]?.Filter;
  const reportTitle = headerData[0]?.Description;
  useEffect(() => {
    if (id) {
      const now = new Date();

      const currentMonthName = now.toLocaleString("default", { month: "long" });
      const currentMonthOption = monthOptions.find(
        (m) => m.value === currentMonthName,
      );

      const currentYear = String(now.getFullYear());
      const currentYearOption = yearOptions.find(
        (y) => y.value === currentYear,
      );
      setSelectedFormatedStDt("");
      setSelectedFormatedEndDt("");
      setSelectedStartDt(new Date().toISOString().split("T")[0]);
      setSelectedEndDt(new Date().toISOString().split("T")[0]);

      setSelectedmonth(
        reportFilters?.includes("Month") ? currentMonthOption || null : null,
      );

      Setselectedyear(
        reportFilters?.includes("Year") ? currentYearOption || null : null,
      );
      setData([]);
    }
  }, [id, reportFilters]);

  const columnsTanStack = useMemo(() => {
    return headers?.length
      ? buildColumns(headers, pageIndex, pageSize, id)
      : [];
  }, [headers, pageIndex, pageSize, id]);

  const table = useReactTable({
    data: filteredData,
    columns: columnsTanStack,
    state: {
      pagination: { pageIndex, pageSize },
    },
    onPaginationChange: (updater) => {
      const next =
        typeof updater === "function"
          ? updater({ pageIndex, pageSize })
          : updater;
      setPageIndex(next.pageIndex);
    },
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });
  const fetchReportData = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPageIndex(0);
    if (tokenData && superIdData) {
      try {
        const queryParams = new URLSearchParams({
          reportiid: id,
          superid: superIdData,
        });

        if (selectedFormattedStDt) {
          queryParams.append("StartDate", selectedFormattedStDt);
        } else {
          queryParams.append("StartDate", selectedStartDt);
        }
        if (selectedFormattedEndDt) {
          queryParams.append("EndDate", selectedFormattedEndDt);
        } else {
          queryParams.append("EndDate", selectedEndDt);
        }

        if (selectedEmp?.value) queryParams.append("RegId", selectedEmp.value);
        if (selectedDep?.value) queryParams.append("DeptId", selectedDep.value);
        if (id === "200") {
          queryParams.append("ShiftId", "1");
        }
        if (id === "201") {
          queryParams.append("ShiftId", "7");
        }
        if (id === "202") {
          queryParams.append("ShiftId", "12");
        } else if (selectedShift?.value) {
          queryParams.append("ShiftId", selectedShift.value);
        }
        if (selectedBranch?.value)
          queryParams.append("BranchId", selectedBranch.value);

        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/reports/getReports?${queryParams.toString()}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        const result = await response.json();

        if (result?.status) {
          setHeaders(result.header);
          setData(result.ResultData);

          const originalHeaders = result.header;

          const cleanHeaders = originalHeaders.map((h) =>
            h.replace(/\s+/g, "_").toLowerCase(),
          );

          const columns = [
            {
              title: "S.No",
              dataIndex: "serial",
              key: "serial",
              render: (text, record, index) => index + 1,
            },
            ...originalHeaders.map((header, index) => {
              const key = cleanHeaders[index];
              return {
                title: header,
                dataIndex: key,
                key: key,
                sorter: (a, b) => {
                  const valA = a[key];
                  const valB = b[key];

                  const isDateA =
                    typeof valA === "string" &&
                    /^\d{4}-\d{2}-\d{2}T/.test(valA);
                  const isDateB =
                    typeof valB === "string" &&
                    /^\d{4}-\d{2}-\d{2}T/.test(valB);

                  if (isDateA && isDateB) {
                    return new Date(valA) - new Date(valB);
                  }
                  return String(valA).localeCompare(String(valB));
                },
                render: (text) => {
                  const isISODate =
                    typeof text === "string" &&
                    /^\d{4}-\d{2}-\d{2}T/.test(text);
                  return (
                    <span title={text}>
                      {isISODate
                        ? new Date(text).toISOString().split("T")[0]
                        : text?.length > 15
                          ? `${text.substring(0, 15)}...`
                          : text}
                    </span>
                  );
                },
              };
            }),
          ];

          SetColdata(columns);

          const data = result.ResultData.map((row) => {
            const newRow = {};
            originalHeaders.forEach((header, index) => {
              const cleanKey = cleanHeaders[index];
              newRow[cleanKey] = row[header];
            });
            return newRow;
          });

          setReportData(data);
        } else {
          console.error("Error:", result?.Message || "Failed to fetch reports");
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const monthOptions = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
  ];

  const currentYear = new Date().getFullYear();

  const yearOptions = Array.from({ length: 2 }, (_, i) => {
    const year = currentYear - i;
    return { value: String(year), label: String(year) };
  }).reverse();

  useEffect(() => {
    if (selectedmonth?.value && selectedYear?.value) {
      const monthMap = {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
      };

      const selectedMonthNum = monthMap[selectedmonth.value];
      const selectedYearNum = parseInt(selectedYear.value);

      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;

      const isCurrentYear = selectedYearNum === currentYear;
      const isCurrentMonth = isCurrentYear && selectedMonthNum === currentMonth;

      const isFuture =
        selectedYearNum > currentYear ||
        (selectedYearNum === currentYear && selectedMonthNum > currentMonth);

      const startDay = isCurrentMonth || isFuture ? today.getDate() : 1;

      console.log(startDay);

      const startDate = new Date(
        selectedYearNum,
        selectedMonthNum - 1,
        // startDay
        1,
      );

      const endDate = new Date(selectedYearNum, selectedMonthNum, 0);

      const format = (d) => {
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      const formattedStartDate = format(startDate);
      const formattedEndDate = format(endDate);

      setSelectedFormatedStDt(formattedStartDate);
      setSelectedFormatedEndDt(formattedEndDate);
    }
  }, [selectedmonth, selectedYear]);

  useEffect(() => {
    setSelectedEmp(null);
    setSelectedDep(null);
    setSelectedShift(null);
    setSelectedBranch(null);
    setSelectedStartDt(new Date().toISOString().split("T")[0]);
    setSelectedEndDt(new Date().toISOString().split("T")[0]);
    setReportData(null);
    SetColdata(null);
    setHeaderData([]);
  }, [id]);

  const exportToExcel = () => {
    if (!reportData || reportData.length === 0) {
      alert("No data to export!");
      return;
    }

    setExcelLoading(true);

    setTimeout(() => {
      const formattedData = reportData.map((row) => {
        const newRow = {};
        Object.entries(row).forEach(([key, value]) => {
          if (id === "107" && (key === "swipe_location" || key === "map")) {
            return;
          }
          if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
            newRow[key] = new Date(value).toISOString().split("T")[0];
          } else {
            newRow[key] = value;
          }
        });
        return newRow;
      });

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
      XLSX.writeFile(workbook, `${reportName || "Report"}.xlsx`);

      setExcelLoading(false);
    }, 100);
  };

  const exportToPDF = () => {
    if (!reportData || reportData?.length === 0) return;

    setPdfLoading(true);

    setTimeout(() => {
      generatePDF();
      setPdfLoading(false);
    }, 100);
  };

  const generatePDF = () => {
    const HIDE_TITLES_107 = ["map", "swipe location", "swipe_location"];

    let filteredColData =
      id === "107"
        ? colData.filter(
            (col) => !HIDE_TITLES_107.includes(col.title?.toLowerCase().trim()),
          )
        : [...colData];

    const doc = new jsPDF({ orientation: "portrait" });

    const timestamp = new Date().toLocaleString();

    const tableColumn = filteredColData.map((col) => col.title);

    const tableRows = reportData.map((row, rowIndex) =>
      filteredColData.map((col) => {
        if (col.title === "S.No") return rowIndex + 1;

        let value = row[col.dataIndex];

        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
          value = new Date(value).toISOString().split("T")[0];
        }

        return value ?? "NA";
      }),
    );

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 18,
      styles: { fontSize: 9 },
      margin: { top: 15, bottom: 20, left: 10, right: 10 },

      didDrawPage: function () {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.setFontSize(14);
        doc.text(reportName, pageWidth / 2, 10, { align: "center" });

        doc.setFontSize(8);
        doc.text(`Generated: ${timestamp}`, pageWidth - 10, 10, {
          align: "right",
        });

        doc.text(
          "RollCall Attendance System. Powered by Perennial Code IT Consultants",
          pageWidth / 2,
          pageHeight - 10,
          { align: "center" },
        );
      },
    });

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      doc.setFontSize(8);

      doc.text(`Page ${i} of ${totalPages}`, pageWidth - 10, pageHeight - 10, {
        align: "right",
      });
    }

    doc.save(`${reportName}.pdf`);
  };

  const handleReload = () => {
    window.location.reload();
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const renderFilters = () => {
    return (
      <div className="row align-items-end">
        <div className="col-lg-12">
          <div className="row">
            {reportFilters?.includes("Month") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Month :</label>
                  <Select
                    classNamePrefix="react-select"
                    options={monthOptions}
                    placeholder="Choose month"
                    allowClear
                    value={selectedmonth}
                    onChange={setSelectedmonth}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("Year") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Year</label>
                  <Select
                    classNamePrefix="react-select"
                    options={yearOptions}
                    placeholder="Choose year"
                    allowClear
                    value={selectedYear}
                    onChange={Setselectedyear}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("StartDate") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={selectedStartDt}
                    onChange={handleStartDtChange}
                  ></input>
                </div>
              </div>
            )}
            {reportFilters?.includes("EndDate") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={selectedEndDt}
                    onChange={handleEndDtChange}
                  ></input>
                </div>
              </div>
            )}
            {reportFilters?.includes("payperiod") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Pay Period</label>
                  <Select
                    classNamePrefix="react-select"
                    allowClear
                    options={[
                      { value: "Mar-2025", label: "Mar-2025" },
                      { value: "Feb-2025", label: "Feb-2025" },
                      { value: "Jan-2025", label: "Jan-2025" },
                      { value: "Dec-2024", label: "Dec-2024" },
                      { value: "Nov-2024", label: "Nov-2024" },
                      { value: "Oct-2024", label: "Oct-2024" },
                      { value: "Sep-2024", label: "Sep-2024" },
                      { value: "Aug-2024", label: "Aug-2024" },
                      { value: "Jul-2024", label: "Jul-2024" },
                      { value: "Jun-2024", label: "Jun-2024" },
                      { value: "May-2024", label: "May-2024" },
                      { value: "Apr-2024", label: "Apr-2024" },
                    ]}
                    placeholder="Choose Pay Period"
                    // onChange={(e) => handleFilterChange("payperiod", e.value)}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("Branch") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Branch</label>
                  <Select
                    placeholder="Branch"
                    value={selectedBranch}
                    onChange={setSelectedBranch}
                    allowClear
                    options={branchOptions}
                    style={{ width: 170 }}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("Dept") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Department</label>
                  <Select
                    placeholder="Department"
                    value={selectedDep}
                    onChange={setSelectedDep}
                    allowClear
                    options={departmentOptions}
                    style={{ width: 170 }}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("Employee") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Employee</label>
                  <Select
                    placeholder="Employee"
                    value={selectedEmp}
                    onChange={setSelectedEmp}
                    allowClear
                    options={empOptions}
                    style={{ width: 200 }}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("shift") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Shift</label>
                  <Select
                    placeholder="Shifts"
                    value={selectedShift}
                    onChange={setSelectedShift}
                    allowClear
                    options={shiftOptions}
                    style={{ width: 170 }}
                  />
                </div>
              </div>
            )}
            <div className="col-md-1 mt-4">
              <button
                className="btn btn-primary mt-1"
                type="submit"
                onClick={fetchReportData}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
            <div className="col-md-1 mt-4">
              <button
                className={`btn btn-${activeKey ? `secondary` : `primary`} mt-1`}
                onClick={togglePanel}
              >
                <i className={`fa ${activeKey ? "fa-x" : "fa-filter"}`}></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-lg-2"></div>
      </div>
    );
  };

  useEffect(() => {
    setPageIndex(0);
    setHeaders([]);
    setSearchText("");
  }, [id]);

  return (
    <>
      {(pdfLoading || excelLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      {headerLoading ? (
        <div className="page-wrapper">
          <div className="content d-flex justify-content-center align-items-center">
            <Spin size="large" />
          </div>
        </div>
      ) : (
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/rollcall/dashboard">
                          <i className="fas fa-home fa-lg" />
                        </Link>
                      </li>
                      <h4 className="breadcrumb-item " aria-current="page">
                        {reportName}
                      </h4>
                    </ol>
                  </nav>
                  <h6>Manage {reportTitle}</h6>
                </div>
              </div>
              {perm.Export && (
                <ul className="table-top-head">
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={exportToPDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={exportToExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>

                  <li onClick={handleReload}>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderRefreshTooltip}
                    >
                      <Link data-bs-toggle="tooltip" data-bs-placement="top">
                        <RotateCcw />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </ul>
              )}
            </div>
            {perm.Read ? (
              <>
                <style>
                  {`
                    .ant-collapse .ant-collapse-content .ant-collapse-content-box {
                      padding: 0px;
                    }

                    .ant-collapse .ant-collapse-item .ant-collapse-header {
                      padding: 0px;
                    }
                  `}
                </style>
                <Collapse activeKey={activeKey} ghost expandIcon={() => null}>
                  <Panel key="1">
                    <div className="card border-0">
                      <div className="card-body">{renderFilters()}</div>
                    </div>
                  </Panel>
                </Collapse>

                <div className="card  ">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Search..."
                      value={searchText}
                      onChange={handleSearch}
                      style={{ width: "250px" }}
                    />
                    {activeKey === null && (
                      <button
                        className={`btn btn-${activeKey ? `secondary` : `primary`} mt-1`}
                        onClick={togglePanel}
                      >
                        <i
                          className={`fa ${activeKey ? "fa-x" : "fa-filter"}`}
                        ></i>
                      </button>
                    )}
                  </div>

                  <div className="card-body">
                    <div className="">
                      {Loading ? (
                        <div className="text-center my-4">
                          <Spin size="large" />
                          <p>Loading data...</p>
                        </div>
                      ) : (
                        <>
                          {!Loading && (
                            <>
                              <div className="table-responsive brand-table">
                                <div className="dataTables_wrapper dt-bootstrap5 no-footer table-responsive">
                                  <table className="table datatable dataTable no-footer">
                                    <thead className="">
                                      {table?.getHeaderGroups()?.map((hg) => (
                                        <tr key={hg.id}>
                                          {hg.headers.map((h) => (
                                            <th
                                              key={h.id}
                                              style={{ cursor: "pointer" }}
                                            >
                                              {flexRender(
                                                h.column.columnDef.header,
                                                h.getContext(),
                                              )}
                                            </th>
                                          ))}
                                        </tr>
                                      ))}
                                    </thead>
                                    <tbody>
                                      {table
                                        ?.getRowModel()
                                        ?.rows?.map((row) => (
                                          <tr
                                            className="border border-start-0 border-end-0"
                                            key={row.id}
                                          >
                                            {row
                                              .getVisibleCells()
                                              .map((cell) => (
                                                <td key={cell.id}>
                                                  {flexRender(
                                                    cell.column.columnDef.cell,
                                                    cell.getContext(),
                                                  )}
                                                </td>
                                              ))}
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    Page size
                                    <Select
                                      value={pageSizeOptions.find(
                                        (opt) => opt.value === pageSize,
                                      )}
                                      onChange={(option) =>
                                        setPageSize(option.value)
                                      }
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      options={pageSizeOptions}
                                      styles={{
                                        container: (base) => ({
                                          ...base,
                                          width: 120,
                                        }),
                                      }}
                                    />
                                  </div>
                                  <PaginationControls
                                    pageIndex={pageIndex}
                                    totalPages={table.getPageCount()}
                                    setPageIndex={setPageIndex}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="card">
                <div className="card-body d-flex justify-content-center">
                  <h1>You dont have access to this page</h1>
                </div>
              </div>
            )}
          </div>
          <CommonFooter />
        </div>
      )}
    </>
  );
};

export default RollcallReports;

const PaginationControls = ({ pageIndex, totalPages, setPageIndex }) => (
  <div className="d-flex justify-content-end py-3 mt-2">
    <button
      className="btn btn-primary btn-sm me-2"
      onClick={() => setPageIndex(0)}
      disabled={pageIndex === 0}
      title="first"
    >
      <i className="fa-solid fa-backward-fast"></i>
    </button>
    <button
      className="btn btn-primary btn-sm me-2"
      onClick={() => setPageIndex((p) => Math.max(p - 1, 0))}
      disabled={pageIndex === 0}
    >
      <i className="fa-solid fa-backward-step"></i>
    </button>

    <span>
      Page {pageIndex + 1} of {totalPages}
    </span>

    <button
      className="btn btn-primary btn-sm mx-2"
      onClick={() => setPageIndex((p) => Math.min(p + 1, totalPages - 1))}
      disabled={pageIndex >= totalPages - 1}
    >
      <i className="fa-solid fa-forward-step"></i>
    </button>
    <button
      className="btn btn-primary btn-sm me-2"
      onClick={() => setPageIndex(totalPages - 1)}
      disabled={pageIndex >= totalPages - 1}
    >
      <i className="fa-solid fa-forward-fast"></i>
    </button>
  </div>
);

PaginationControls.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  setPageIndex: PropTypes.func.isRequired,
};
